const asset = require('./asset');
const blockTransformer = require('./block');
const isResolvedCollection = require('../contentful/is-resolved-collection');
const isResolvedResource = require('../contentful/is-resolved-resource');
const makeTransformer = require('./make');
const makeImageTransformer = require('./makeImage');
const _ = require('lodash');

const createAssetLink = (asset) => {
  return {
    sys: {
      type: 'Link',
      linkType: 'Asset',
      id: asset.id
    }
  };
};

const createEntryLink = (entry) => {
  return {
    sys: {
      type: 'Link',
      linkType: 'Entry',
      id: entry.id
    }
  };
};

module.exports = {
  contentfulToInternal(entry) {
    // console.log("entry", entry);
    const result = {
      id: entry.sys.id,
      published: Boolean(entry.sys.publishedVersion),
      updated: entry.sys.publishedVersion && entry.sys.version > entry.sys.publishedVersion + 1,
      draft: !entry.sys.publishedVersion,
      archived: Boolean(entry.sys.archivedVersion),
      contentType: null,

      name: entry.fields.name['nb-NO'],
      shortname: (entry.fields.shortname ? entry.fields.shortname['nb-NO'] : ''),
      firmSyncName: (entry.fields.firmSyncName ? entry.fields.firmSyncName['nb-NO'] : null),
      image: null,
      logo: null,
      logoBright: null,
      slideshow: [],
      about: [],
      slug: (entry.fields.slug ? entry.fields.slug['nb-NO'] : ''),
      address: (entry.fields.address ? entry.fields.address['nb-NO'] : ''),
      zipcode: (entry.fields.zipcode ? _.padStart(entry.fields.zipcode['nb-NO'], 4, '0') : ''),
      ziparea: (entry.fields.ziparea ? entry.fields.ziparea['nb-NO'] : ''),
      websiteUrl: (entry.fields.websiteUrl ? entry.fields.websiteUrl['nb-NO'] : ''),
      phone: (entry.fields.phone ? entry.fields.phone['nb-NO'] : ''),
      openinghours: (entry.fields.openinghours ? entry.fields.openinghours['nb-NO'] : ''),
      openinghoursDeviation: (entry.fields.openinghoursDeviation ? entry.fields.openinghoursDeviation['nb-NO'] : ''),
      openinghoursDeviationActive: (entry.fields.openinghoursDeviationActive ? entry.fields.openinghoursDeviationActive['nb-NO'] : false),
      openingHoursDeviationFromdate: null,
      openingHoursDeviationTodate: null,
      openinghoursDeviationTitle: (entry.fields.openinghoursDeviationTitle ? entry.fields.openinghoursDeviationTitle['nb-NO'] : ''),
      openinghoursDeviationDisclaimer: (entry.fields.openinghoursDeviationDisclaimer ? entry.fields.openinghoursDeviationDisclaimer['nb-NO'] : ''),
      crossEmployees: [],
      makes: [],
      makeIds: [],
      priceadjustment: (entry.fields.priceadjustment ? entry.fields.priceadjustment['nb-NO'] : ''),
      modelsPriceAdjustments: (entry.fields.modelsPriceAdjustments ? entry.fields.modelsPriceAdjustments['nb-NO'] : []),
      modelsBlacklist: (entry.fields.modelsBlacklist ? entry.fields.modelsBlacklist['nb-NO'] : []),

      // These fields have been moved to a single JSON field "googleAnalytics"
      googleAnalyticsId: null,
      googleAnalyticsIdMitsubishi: null,

      isMotorforumDealer: false,
      finnOrgId: (entry.fields.finnOrgId ? entry.fields.finnOrgId['nb-NO'] : null),
      externalRef: (entry.fields.externalRef ? entry.fields.externalRef['nb-NO'] : ''),
      groupTags: [],
      deliveryShortDescription: (entry.fields.deliveryShortDescription ? entry.fields.deliveryShortDescription['nb-NO'] : null),
      deliveryLongDescription: (entry.fields.deliveryLongDescription ? entry.fields.deliveryLongDescription['nb-NO'] : null),
      skipBuild: (entry.fields.skipBuild ? entry.fields.skipBuild['nb-NO'] : false),
      availableOnMinSide: (entry.fields.availableOnMinSide ? entry.fields.availableOnMinSide['nb-NO'] : null),
      nordea: (entry.fields.nordea ? entry.fields.nordea['nb-NO'] : false),

      // These fields have is a single JSON field "nordeaConfig"
      // nordeaConfig: (entry.fields.nordeaConfig ? entry.fields.nordeaConfig['nb-NO'] : null),
      nordeaBranchId: null,
      nordeaVendorId: null,

      // These fields have been moved to a single JSON field "onlineBooking"
      onlineBookingMitsubishi: false,
      onlineBookingHongqi: false,

      useNameInMapLookup: (entry.fields.useNameInMapLookup ? entry.fields.useNameInMapLookup['nb-NO'] : false),
      gpsLocation: (entry.fields.gpsLocation ? entry.fields.gpsLocation['nb-NO'] : {}),

      digitalConsultingEnabled: false,
      digitalConsultingFreetext: false,
      digitalConsultingPlatforms: {},
      makeImages: []
    };

    if (entry.sys && entry.sys.contentType) {
      result.contentType = entry.sys.contentType.sys.id;
    }

    if (entry.fields.groupTags && entry.fields.groupTags['nb-NO']) {
      result.groupTags = entry.fields.groupTags['nb-NO'];
    }

    // Images
    if (entry.fields.image && entry.fields.image['nb-NO'] && isResolvedResource(entry.fields.image['nb-NO'])) {
      result.image = asset.contentfulToInternal(entry.fields.image['nb-NO']);
    }
    if (entry.fields.logo && entry.fields.logo['nb-NO'] && isResolvedResource(entry.fields.logo['nb-NO'])) {
      result.logo = asset.contentfulToInternal(entry.fields.logo['nb-NO']);
    }
    if (entry.fields.logoBright && entry.fields.logoBright['nb-NO'] && isResolvedResource(entry.fields.logoBright['nb-NO'])) {
      result.logoBright = asset.contentfulToInternal(entry.fields.logoBright['nb-NO']);
    }

    // Employees
    if (entry.fields.crossEmployees && entry.fields.crossEmployees['nb-NO']) {
      // Note: We do not convert from contentful to internal because of circular issues with require
      result.crossEmployees = entry.fields.crossEmployees['nb-NO'];
    }

    // makes
    if (entry.fields.makes && entry.fields.makes['nb-NO']) {
      // Generate array of makeIds
      result.makeIds = entry.fields.makes['nb-NO'].map((make) => {
        return make.sys.id;
      });

      if (isResolvedCollection(entry.fields.makes['nb-NO'])) {
        result.makes = entry.fields.makes['nb-NO'].map(makeTransformer.contentfulToInternal);
      }
    }

    // "About dealer" content blocks:
    if (entry.fields.about && entry.fields.about['nb-NO'] && isResolvedCollection(entry.fields.about['nb-NO'])) {
      result.about = entry.fields.about['nb-NO'].map(blockTransformer.contentfulToInternal);
    }

    // Opening hours deviation dates
    if (entry.fields.openingHoursDeviationFromdate && entry.fields.openingHoursDeviationFromdate['nb-NO']) {
      result.openingHoursDeviationFromdate = new Date(entry.fields.openingHoursDeviationFromdate['nb-NO']);
    }
    if (entry.fields.openingHoursDeviationTodate && entry.fields.openingHoursDeviationTodate['nb-NO']) {
      result.openingHoursDeviationTodate = new Date(entry.fields.openingHoursDeviationTodate['nb-NO']);
    }

    if (entry.fields.isMotorforumDealer) {
      result.isMotorforumDealer = (entry.fields.isMotorforumDealer['nb-NO'] === true);
    }

    if (entry.fields.slideshow && entry.fields.slideshow['nb-NO'] && isResolvedCollection(entry.fields.slideshow['nb-NO'])) {
      result.slideshow = entry.fields.slideshow['nb-NO'].map(asset.contentfulToInternal);
    }

    if (entry.fields.digitalConsulting && entry.fields.digitalConsulting['nb-NO']) {
      result.digitalConsultingEnabled = entry.fields.digitalConsulting['nb-NO'].enabled;
      result.digitalConsultingFreetext = entry.fields.digitalConsulting['nb-NO'].freetext;
      result.digitalConsultingPlatforms = entry.fields.digitalConsulting['nb-NO'].platforms;
    }

    if (entry.fields.googleAnalytics && entry.fields.googleAnalytics['nb-NO']) {
      result.googleAnalyticsId = entry.fields.googleAnalytics['nb-NO'].id;
      result.googleAnalyticsIdMitsubishi = entry.fields.googleAnalytics['nb-NO'].mitsubishi;
    }

    if (entry.fields.nordeaConfig && entry.fields.nordeaConfig['nb-NO']) {
      result.nordeaBranchId = entry.fields.nordeaConfig['nb-NO'].branchId || null;
      result.nordeaVendorId = entry.fields.nordeaConfig['nb-NO'].vendorId || null;
    }

    if (entry.fields.onlineBooking && entry.fields.onlineBooking['nb-NO']) {
      result.onlineBookingMitsubishi = entry.fields.onlineBooking['nb-NO'].mitsubishi || false;
      result.onlineBookingHongqi = entry.fields.onlineBooking['nb-NO'].hongqi || false;
    }

    if (entry.fields.makeImages && entry.fields.makeImages['nb-NO'] && isResolvedCollection(entry.fields.makeImages['nb-NO'])) {
      result.makeImages = entry.fields.makeImages['nb-NO'].map(makeImageTransformer.contentfulToInternal);
    }

    // Update model status based on content blocks status
    result.about.forEach((rd) => {
      if (!rd.published || rd.updated) {
        result.updated = true;
      }
    });

    return result;
  },

  internalToContentful(dealer) {
    // console.log('Dealer', dealer);
    const result = {
      fields: {
        name: {
          'nb-NO': dealer.name
        },
        shortname: {
          'nb-NO': dealer.shortname
        },
        firmSyncName: {
          'nb-NO': dealer.firmSyncName
        },
        slug: {
          'nb-NO': dealer.slug
        },
        phone: {
          'nb-NO': dealer.phone
        },
        websiteUrl: {
          'nb-NO': dealer.url
        },
        address: {
          'nb-NO': dealer.address
        },
        zipcode: {
          'nb-NO': parseInt(dealer.zipcode, 10)
        },
        ziparea: {
          'nb-NO': dealer.ziparea
        },
        about: {
          'nb-NO': null
        },
        image: null,
        logo: null,
        logoBright: null,
        priceadjustment: {
          'nb-NO': parseInt(dealer.priceadjustment, 10)
        },
        openinghours: {
          'nb-NO': dealer.openinghours
        },
        openinghoursDeviation: {
          'nb-NO': dealer.openinghoursDeviation
        },
        openinghoursDeviationActive: {
          'nb-NO': dealer.openinghoursDeviationActive === true
        },
        openingHoursDeviationFromdate: null,
        openingHoursDeviationTodate: null,
        openinghoursDeviationTitle: {
          'nb-NO': dealer.openinghoursDeviationTitle
        },
        openinghoursDeviationDisclaimer: {
          'nb-NO': dealer.openinghoursDeviationDisclaimer
        },
        modelsBlacklist: {
          'nb-NO': dealer.modelsBlacklist
        },
        modelsPriceAdjustments: {
          'nb-NO': dealer.modelsPriceAdjustments
        },
        finnOrgId: null,
        externalRef: null,
        deliveryShortDescription: null,
        deliveryLongDescription: null,
        skipBuild: {
          'nb-NO': dealer.skipBuild === true
        },
        availableOnMinSide: {
          'nb-NO': dealer.skipBuild === true && dealer.availableOnMinSide === true
        },
        nordea: {
          'nb-NO': dealer.nordea === true
        },
        useNameInMapLookup: {
          'nb-NO': dealer.useNameInMapLookup === true
        },
        digitalConsulting: null,
        onlineBooking: null,
        googleAnalytics: null,

        makeImages: dealer.makeImages ?? []
      },
      overwriteKeys: []
    };

    if (dealer.image) {
      result.fields.image = {
        'nb-NO': createAssetLink(dealer.image)
      };
    }

    if (dealer.logo) {
      result.fields.logo = {
        'nb-NO': createAssetLink(dealer.logo)
      };
    }

    if (dealer.logoBright) {
      result.fields.logoBright = {
        'nb-NO': createAssetLink(dealer.logoBright)
      };
    }

    if (dealer.makes) {
      result.fields.makes = {
        'nb-NO': dealer.makes.map(createEntryLink)
      };
    }

    // Group tags
    let groupTags = [];
    if (dealer.groupTags.length > 0) {
      groupTags = dealer.groupTags;
    }
    result.fields.groupTags = {
      'nb-NO': groupTags
    };

    if (dealer.openingHoursDeviationFromdate) {
      // Format: YYYY-MM-DD
      result.fields.openingHoursDeviationFromdate = {
        'nb-NO': dealer.openingHoursDeviationFromdate.toISOString().split('T')[0]
      };
    }

    if (dealer.openingHoursDeviationTodate) {
      // Format: YYYY-MM-DD
      result.fields.openingHoursDeviationTodate = {
        'nb-NO': dealer.openingHoursDeviationTodate.toISOString().split('T')[0]
      };
    }

    if (dealer.about) {
      result.fields.about = {
        'nb-NO': dealer.about.map(createEntryLink)
      };
    }

    if (dealer.slideshow) {
      result.fields.slideshow = {
        'nb-NO': dealer.slideshow.map(createAssetLink)
      };
    }

    if (dealer.finnOrgId) {
      result.fields.finnOrgId = {
        'nb-NO': dealer.finnOrgId
      };
    }

    if (dealer.externalRef) {
      result.fields.externalRef = {
        'nb-NO': dealer.externalRef
      };
    }

    if (dealer.deliveryShortDescription) {
      result.fields.deliveryShortDescription = {
        'nb-NO': dealer.deliveryShortDescription
      };
    }
    if (dealer.deliveryLongDescription) {
      result.fields.deliveryLongDescription = {
        'nb-NO': dealer.deliveryLongDescription
      };
    }

    if (dealer.gpsLocationLat || dealer.gpsLocationLon) {
      result.fields.gpsLocation = {
        'nb-NO': {
          lat: parseFloat(dealer.gpsLocationLat || dealer.gpsLocation.lat),
          lon: parseFloat(dealer.gpsLocationLon || dealer.gpsLocation.lon)
        }
      };
    }

    if (dealer.digitalConsultingEnabled) {
      result.fields.digitalConsulting = {
        'nb-NO': {
          enabled: true,
          freetext: dealer.digitalConsultingFreetext,
          platforms: dealer.digitalConsultingPlatforms
        }
      };

      result.overwriteKeys.push('digitalConsulting');
    }

    if (
      dealer.nordeaBranchId !== null ||
      dealer.nordeaVendorId !== null
    ) {
      result.fields.nordeaConfig = {
        'nb-NO': {
          branchId: dealer.nordeaBranchId || null,
          vendorId: dealer.nordeaVendorId || null
        }
      };
    }

    if (
      dealer.onlineBookingMitsubishi ||
      dealer.onlineBookingHongqi
    ) {
      result.fields.onlineBooking = {
        'nb-NO': {
          mitsubishi: (dealer.onlineBookingMitsubishi === 'true' || dealer.onlineBookingMitsubishi === true),
          hongqi: (dealer.onlineBookingHongqi === 'true' || dealer.onlineBookingHongqi === true)
        }
      };
    }

    if (
      dealer.googleAnalyticsId ||
      dealer.googleAnalyticsIdMitsubishi
    ) {
      result.fields.googleAnalytics = {
        'nb-NO': {
          id: dealer.googleAnalyticsId || undefined,
          mitsubishi: dealer.googleAnalyticsIdMitsubishi || undefined,
        }
      };
    }

    if (dealer.makeImages) {
      result.fields.makeImages = {
        'nb-NO': dealer.makeImages.map(createEntryLink)
      };
    }

    return result;
  }
};
